<div
  (click)="onProductClick(product)"
  class="h-full flex justify-between flex-col cursor-pointer text-sm font-bold rounded-lg border-separate bg-white shadow-S overflow-hidden"
  [class.opacity-40]="!isAvailable(product) || !isOrderingAllowed"
  [class.cursor-pointer]="isAvailable(product) && isOrderingAllowed"
>
  <div
    *ngIf="product?.images?.thumbnail?.url"
    class="bg-neutral-50"
    [style.backgroundColor]="productImagePlaceholderColor | contentBuilderColor"
  >
    <img
      [src]="product?.images?.thumbnail?.url"
      class="w-full rounded-t-lg h-36 max-h-36 lg:h-52 lg:max-h-52 w-full object-cover"
      alt="img"
    />
  </div>
  <div class="px-3 py-2 h-full text-sm flex flex-col justify-between">
    <p
      class="font-bold font-accent text-sm lg:text-base break-words pt-1 pb-1 lg:pb-2"
      [style.color]="productNameColor | contentBuilderColor"
    >
      {{ product[ProductKeys.Name] }}
    </p>
    <div
      *ngIf="!product[ProductKeys.PriceToDisplay]"
      class="text-right"
      [style.color]="productPriceColor | contentBuilderColor"
    >
      <ng-container *ngIf="product[ProductKeys.Discount]; else priceOnly">
        <app-price-atom
          class="pl-0 p-1.5"
          [amount]="product[ProductKeys.Discount]"
        ></app-price-atom>
        <app-tag-atom
          *ngIf="product[ProductKeys.Price] > 0"
          class="p-1.5"
          color="success"
          text="{{ product[ProductKeys.Price] | discountPercent: product[ProductKeys.Discount] }}"
        ></app-tag-atom>
      </ng-container>
      <ng-template #priceOnly>
        <app-price-atom
          class="pl-0 pb-1"
          [amount]="product[ProductKeys.Price]"
        ></app-price-atom>
      </ng-template>
    </div>
    <div
      *ngIf="product[ProductKeys.PriceToDisplay]"
      [style.color]="productPriceColor | contentBuilderColor"
    >
      <span> {{ product[ProductKeys.PriceToDisplay] }}</span>
    </div>
  </div>
</div>
